import React, { useState, Fragment } from "react";
import ExtraFieldAdd from "./AddFieldDrawer";
import { Tooltip } from "@mui/material";
import CreateViewDialog from "./TableThead/CreateViewDialog";
import ManageIcon from "../../../assets/images/icons/ManageIcon";

const Setting = ({
  setExtraField,
  extraField,
  children,
  setMenuVisible,
  menuVisible,
  handleMenuToggle,
  ApplyHeader,
  thead,
  ExtraFieldAddHeader,
  EditFieldData,
  fromPage,
  columnVisibility,
  setColumnVisibility,
}) => {
  const [showCreateVieweDialog, setShowCreateVieweDialog] = useState(false);
  const [isMangeHovered, setIsMangeHovered] = useState(false);

  const handleClickCreateViewDialog = () => {
    setShowCreateVieweDialog(true);
  };

  return (
    <Fragment>
      <Tooltip
        placement="top"
        title="Manage Field"
        PopperProps={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, -5],
              },
            },
          ],
        }}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "black",
              color: "white",
              boxShadow: "none",
              height: "23px",
              display: "flex",
              alignItems: "center",
            },
          },
        }}
      >
        <label
          htmlFor="open-menu"
          tabIndex="0"
          aria-haspopup="true"
          role="button"
          aria-controls="menu"
          className="tooltip cursor-pointer"
          id="openmenu"
        >
          <ManageIcon isActive={menuVisible} isHovered={isMangeHovered} />
          {/* <i
            className={` bi bi-list tableheadermenuicon tableheaderfiltericon  hover:text-254155 group-focus-within:text-white ${
              menuVisible ? "text-254155 border border-253E50 px-1 rounded" : "text-2541558A"
            }  `}
          ></i> */}
          {/* <span className={`tooltiptext text-[10px] w-max bottom-full left-1/2 ml-[-50px] `}>Manage Field</span> */}
        </label>
      </Tooltip>
      <input
        type="checkbox"
        data-menu
        id="open-menu"
        className="peer hidden"
        checked={menuVisible}
        onChange={handleMenuToggle}
      />

      {menuVisible && (
        <aside className={`fixed right-0 bottom-0 flex z-[99]  `} role="menu" id="menu" aria-labelledby="openmenu">
          {/* <label
          htmlFor="open-menu"
          className={`flex ${extraField ? "w-full md:w-[58.5%]" : "w-full"}`}
        ></label> */}

          {extraField && (
            <Fragment>
              <div className="flex flex-col w-full sm:w-[90%] md:w-[400px] lg:w-[400px] h-full md:h-auto lg:h-[500px] relative z-10 ">
                {/* <label htmlFor="open-menu" className="h-[86px]"></label> */}
                <div className="pr-2">
                  <ExtraFieldAdd
                    setExtraField={setExtraField}
                    ExtraFieldAddHeader={ExtraFieldAddHeader}
                    EditFieldData={EditFieldData}
                  />
                </div>
              </div>

              <div className="fixed inset-0 bg-gray-900 bg-opacity-50 z-0"></div>
            </Fragment>
          )}
          <nav className="translate-x-[0%] text-1E1E1E font-poppins text-16 font-medium transition-all duration-500 box-border flex flex-col w-[20vw] min-w-[380px] h-[calc(100vh-80px)] peer-checked:transform-none peer-checked:opacity-100 self-end z-10">
            {/* <nav className="translate-x-[0%] text-1E1E1E font-poppins text-16 font-medium transition-all duration-500 box-border flex flex-col w-full sm:w-[90%] md:w-[00px] lg:w-[400px] h-[calc(100vh-86px)] md:h-auto absolute   peer-checked:transform-none peer-checked:opacity-100 bottom-0 right-0"> */}
            {/* <nav className=" translate-x-[0%] text-1E1E1E font-poppins text-16 font-medium transition-all duration-500   box-border flex flex-col w-[400px] h-[calc(100vh-86px)] peer-checked:transform-none peer-checked:opacity-100 absolute bottom-0 right-0"> */}
            {/* <label htmlFor="open-menu" className='h-[18%]'>

                     </label> */}

            {/* <div className='relative top-[20%] lg:top-[32%] xl:top-[32%] 2xl:top-[19%] bg-white' id='customShadow'> */}

            <div className="bg-white flex flex-col h-full" id="customShadow">
              <div className="flex justify-between items-center px-4 py-2">
                <h2 className="text-1D4469  text-xl  font-poppins font-bold uppercase">MANAGE FIELD</h2>
                <div className="flex justify-between space-x-2">
                  {/* <div>
                    <button
                      className="border-1 py-1 px-3 rounded font-poppins text-base font-600  bg-1D4469 text-white"
                      onClick={handleClickCreateViewDialog}
                    >
                      Create View
                    </button>
                    {showCreateVieweDialog && (
                      <CreateViewDialog open={showCreateVieweDialog} close={() => setShowCreateVieweDialog(false)} />
                    )}
                  </div> */}
                  <div>
                    {fromPage !== "All Tasks" && (
                      <button
                        className="border-1 py-1 px-4 rounded font-poppins text-base font-600  bg-1D4469 text-white"
                        onClick={() => {
                          ApplyHeader();
                          setTimeout(() => {
                            handleMenuToggle();
                          }, 400);
                        }}
                      >
                        APPLY
                      </button>
                    )}

                    <button onClick={handleMenuToggle} className="ms-2">
                      {" "}
                      <i className="bi bi-x-circle-fill"></i>{" "}
                    </button>
                  </div>
                </div>
              </div>

              {children}
              {/* <CustomerAccordionItem title="Item 2" handleClick={() => SettingSideDrop(1)} isOpen={settingFilter === 1}>
                            Content for item 2
                          </CustomerAccordionItem>
                          <CustomerAccordionItem title="Item 3" handleClick={() => SettingSideDrop(2)} isOpen={settingFilter === 2}>
                            Content for item 3
                          </CustomerAccordionItem> */}
            </div>
          </nav>
        </aside>
      )}
      <div
        className={`absolute top-0 bg-drawerActiveBg h-full pointer-events-none ${
          menuVisible ? "block animate-fadeIn" : "hidden"
        }`}
      ></div>
    </Fragment>
  );
};

export default Setting;
